module.exports = __webpack_public_path__ + "static/media/COVID-Icons_Distance.f6d6efe1.png";